export default {
	name : "menu",
    _toggles: [],
    _menu: null,
    _hamburger: null,
    constructor(){
        this._toggles = document.querySelectorAll('.js-menu-toggle');
        this._menu = document.querySelector('.js-menu');
        this._hamburger = document.querySelector('.js-hamburger');
        this._uiElements = document.querySelectorAll('.js-menu-item, .js-submmenu-trigger');
        this._submenuTriggers = document.querySelectorAll('.js-submmenu-trigger');
    },
    init() {
		this.constructor();
        this.run();
    },
    run(){
        this.watch();
    },
    watch(){
        this._toggles.forEach(el => {
            el.addEventListener('click', () => {
                this.toggle();
            });
        });

        this._uiElements.forEach(el => {
            el.addEventListener('blur', () => {
                this.loopMenu(el);
            });
        });

        document.addEventListener("keydown", e => {
            if(event.keyCode === 27 && this.isMenuOpen()){
               this.toggle();
           }
        });

        this._submenuTriggers.forEach(el => {
            el.addEventListener('click', () => {
                this.toggleSubmenu(el);
            });
            
        });
    },
    toggle(){
        this.toggleMenu();
        this.toggleHamburger();
        this.toggleBody();
    },
    isMenuOpen(){
        return this.getHamburger().classList.contains('is-active');
    },
    toggleHamburger(){
        let h = this.getHamburger();
        h.classList.toggle('is-active');

        let isOpen =  this.isMenuOpen();
    
        this.updateStatusTexts(h, isOpen);
    },
    toggleBody(){
        document.querySelector('.body').classList.toggle('no-scroll');
    },
    toggleMenu(){
        this._menu.classList.toggle('active');
    },
    toggleSubmenu(el){
        let s = this.getSubmenu(el);
        s.parentElement.classList.toggle('active');
        s.classList.toggle('active');

        let isOpen = s.classList.contains('active');
        this.updateStatusTexts(el, isOpen);
    },
    loopMenu(el){
        if(el == this._uiElements[this._uiElements.length - 1]){
            document.querySelector('.js-menu-item').focus();
        }
    },
    getHamburger(){
        return this._hamburger;
    },
    getSubmenu(el){
        return el.nextElementSibling;
    },
    updateStatusTexts(el, status){
        let dataset = el.dataset;
        el.title = status ? dataset.closeText : dataset.openText;
        el.ariaLabel = status ? dataset.closeText : dataset.openText;
    }
};
